export const config = {
  exampleryServerURI: process.env.REACT_APP_EXAMPLERY_SERVER_URI || 'https://api.examplery.io/graphql/',
  exampleryServerWSURI: process.env.REACT_APP_EXAMPLERY_SERVER_WSURI || 'wss://ws.examplery.io',
  orgDomain: process.env.REACT_APP_EXAMPLERY_ORGDOMAIN || 'examplery.com',
  showInstructionsBeforeTest: process.env.REACT_APP_SHOW_INSTRUCTIONS_BEFORE_TEST || true,
  autoShowInstructionsPopupWhenTestStarts: process.env.REACT_APP_AUTO_SHOW_INSTRUCTIONS_POPUP_WHEN_TEST_STARTS || false

}